import React, { useState } from "react";
import { Box, Checkbox, Dialog, Typography } from "@mui/material";
import { SquareFilledIcon } from "src/Icons/SquareFilledIcon";
import { SquareOutlinedIcon } from "src/Icons/SquareOutlinedIcon";

import { CheckIcon, WarnIcon } from "../../Icons";
import { SubmitButton } from "../Button/SubmitButton";

export const CheckedButton = ({ isConfirm }: any) => {
  return isConfirm ? (
    <SquareOutlinedIcon
      sx={{
        fontSize: "20px",
      }}
    />
  ) : (
    <SquareOutlinedIcon
      sx={{
        fontSize: "20px",
      }}
    />
  );
};

interface DeleteModalProp {
  headerTitle: string;
  title: string;
  subTitle: string;
  description: string;
  isLoading: boolean;
  checkTitle?: string;
  isButtonCancel?: boolean;
  okButtonTitle: string;
  onButtonClick: () => void;
  onButtonCancelClick: () => void;
}

export const DeleteModal = ({
  headerTitle,
  title,
  subTitle,
  description,
  isLoading,
  checkTitle,
  isButtonCancel,
  okButtonTitle,

  onButtonClick,
  onButtonCancelClick,
}: DeleteModalProp) => {
  const [isConfirm, setIsConfirm] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsConfirm(event.target.checked);
  };
  return (
    <Box
      sx={{
        padding: "33px",
        borderRadius: "16px",
        width: "496px",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            width: "80px",
            height: "80px",
            backgroundColor: "rgba(213, 31, 41, 0.1)",
            marginBottom: "24px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              backgroundColor: "#D62F39",
              color: "white",
            }}
          >
            <WarnIcon />
          </Box>
        </Box>

        <Typography
          sx={{
            fontSize: "32px",
            fontWeight: "600",
            color: "#080808",
            marginBottom: "16px",
          }}
        >
          {headerTitle}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#363636",
            marginBottom: "16px",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#1F1F1F",
            marginBottom: "8px",
          }}
        >
          {subTitle}
        </Typography>
        {checkTitle && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& .MuiButtonBase-root ": {
                padding: 0,
              },
            }}
          >
            <Checkbox
              disableRipple
              icon={<SquareOutlinedIcon />}
              checkedIcon={<SquareFilledIcon />}
              checked={isConfirm}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
            />
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#1F1F1F",
                padding: "0 0 0 5px",
              }}
            >
              {checkTitle}
            </Typography>
          </Box>
        )}
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#1F1F1F",
            marginBottom: "40px",
          }}
        >
          {description}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: `${isButtonCancel ? "center" : "space-between"}`,
        }}
      >
        {isButtonCancel ? (
          <SubmitButton
            variant="outlined"
            title="Cancel"
            onClick={onButtonCancelClick}
            sx={{
              display: "none",
              flex: 0.7,
              maxWidth: "208px",
            }}
          />
        ) : (
          <SubmitButton
            variant="outlined"
            title="Cancel"
            onClick={onButtonCancelClick}
            sx={{
              flex: 0.7,
              maxWidth: "208px",
            }}
          />
        )}

        {checkTitle ? (
          <SubmitButton
            disabled={!isConfirm}
            title={okButtonTitle}
            isLoading={isLoading}
            onClick={onButtonClick}
            sx={{
              flex: 0.7,
              maxWidth: "208px",
            }}
          />
        ) : (
          <SubmitButton
            title={okButtonTitle}
            isLoading={isLoading}
            onClick={onButtonClick}
            sx={{
              flex: 0.7,
              maxWidth: "208px",
            }}
          />
        )}
      </Box>
    </Box>
  );
};
